/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactRouteImpl } from "abreact/incubator/ui/app/router/ReactRouteImpl";
import { useOnMount } from "abreact/utils/AbHooks";
import { AbBusyIndicator } from "absdk/commons/ui/misc/AbBusyIndicator";
import { reactRouteRenderContext } from "absdk/preliminary/commons/app/router/AbRouteRender";
import { BrowserRoute } from "abweb/service/router/BrowserRoute";
import * as React from "react";
export const HOME_ALIAS_ROUTE = new ReactRouteImpl("/", {});
export function RootAliasRouteSpecFn(defaultRegRoute) {
  return {
    routeTemplate: "/",
    view: {
      modulePath: () => Promise.resolve({
        GoToFn: gotoProps => {
          const currRRC = React.useContext(reactRouteRenderContext());
          useOnMount(() => {
            const rawRoute = new BrowserRoute(defaultRegRoute.routeSpec.routeTemplate, {}, gotoProps.extraParams);
            const reactRoute = defaultRegRoute.buildRouteFromParams(rawRoute);
            defaultRegRoute.goto(reactRoute.routeProps, {
              routeRenderContext: currRRC,
              addCurrentRouteToBrowserHistory: false // do not put '/' alias in history!
            });
          });
          // In practice, shouldn't ever see AbBusyIndicator as defaultRoute will render quickly...
          // AbBusyIndicator also used by react boostrap workflow long before router started, so 'lazy' loading not needed
          return /*#__PURE__*/React.createElement(AbBusyIndicator, null);
        }
      }),
      exportName: "GoToFn"
    },
    routeParamHandler: {
      propsFromParams: routeParams => ({
        extraParams: {
          ...routeParams.routeExtraParams
        }
      }),
      paramsFromProps: props => ({
        routeParams: {},
        routeExtraParams: {
          ...props.extraParams
        }
      })
    }
  };
}
//# sourceMappingURL=RootAliasRoute.js.map
